import { createContext, useContext } from 'react';

const MenuContext = /*#__PURE__*/createContext(undefined);
const useCurrentMenu = () => {
  return useContext(MenuContext);
};

export { MenuContext, useCurrentMenu };
//# sourceMappingURL=Context.js.map
